import React from "react";
import styled from "styled-components";
import { COLORS } from "../../Helper/Colors";

const Styles = styled.div`
	margin-bottom: 2rem;
	padding: 0 0.5rem;
	width: 100%;
	/* max-height: 150px; */
	/* max-height: calc(100% - 10rem); */
	height: calc(100% - 10rem);
	/* height: 100%; */
	overflow: auto;

	::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}
	::-webkit-scrollbar-track {
		background-color: ${COLORS.light};
		border-radius: 50px;
	}
	::-webkit-scrollbar-thumb {
		background-color: ${COLORS.brand};
		border-radius: 50px;
	}
	table:nth-child(1) {
		border-spacing: 0 1rem;
		border-collapse: separate;
		position: relative;
		/* height: 100%; */
		width: 100%;
		thead {
			position: sticky;
			top: 0;
			z-index: 5;
			background-color: ${COLORS.brandLight};
			tr {
				th {
					padding: 0 1rem;
					text-align: start;
					color: ${COLORS.tableHeader};
					font-weight: 500;
					text-transform: capitalize;
					font-size: 16px;
					/* text-align: center; */
					div {
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}
			}
		}

		tbody {
			tr {
				box-shadow: ${COLORS.tableBoxShadow};
				background-color: ${COLORS.light};
				td {
					padding: 1rem;
					font-size: 14px;
					font-weight: 500;
					text-transform: capitalize;
					/* margin: 10px; */
					:last-child {
						border-bottom-right-radius: 10px;
						border-top-right-radius: 10px;
					}
					:first-child {
						border-bottom-left-radius: 10px;
						border-top-left-radius: 10px;
					}
				}
			}
		}
		tr {
			:last-child {
				td {
					border-bottom: 0;
				}
			}
		}

		th,
		td {
			margin: 0;
			padding: 0.5rem;

			:last-child {
				border-right: 0;
			}
		}
	}
	//For second table
	table:nth-child(2) {
		border-spacing: 0 1rem;
		border: 1px solid #1e1e1e4d;
		position: relative;
		width: 100%;
		thead {
			border-bottom: 1px solid #1e1e1e4d;
			tr {
				th {
					padding: 1rem;
					text-align: center;
					color: ${COLORS.tableHeader};
					font-weight: 500;
					text-transform: capitalize;
					font-size: 14px;
					div {
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}
			}
		}

		tbody {
			tr {
				td {
					text-align: center;
					padding: 1rem;
					font-size: 14px;
					font-weight: 500;
					text-transform: capitalize;
				}
			}
		}
	}
	ul {
		list-style: none;
		display: flex;
		justify-content: center;
		align-items: center;
		li {
			margin: 0 10px;
			font-size: 12px;
			border-radius: 5px;
			padding: 0;
			font-weight: 500;
			height: 30px;
			width: 30px;
			text-align: center;
			a {
				display: inline-block;
				padding: 6px 10px;
				svg: {
					padding: 0;
				}
			}
			&.page-item {
				background-color: ${COLORS.light};
				transition: all 0.25s ease-in-out;
			}
			&.page-item.disabled {
				visibility: hidden;
			}
			&.page-item.active {
				background-color: ${COLORS.brandDark};
				color: ${COLORS.light};
			}
			:first-child {
				a {
					padding: 7px 5px;
				}
				background-color: ${COLORS.brand};
			}
			:last-child {
				a {
					padding: 7px 5px;
				}
				background-color: ${COLORS.brand};
			}
		}
	}
`;
const StylesV6 = styled.div`
	margin-bottom: 2rem;
	padding: 0 0.5rem;
	width: 100%;
	height: calc(100% - 10rem);
	overflow: hidden;
	.ReactTable {
		border: none;
		height: 100%;
		width: 100%;
		overflow: hidden;
		.rt-table {
			overflow: auto;
			::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}
			::-webkit-scrollbar-track {
				background-color: ${COLORS.light};
				border-radius: 50px;
			}
			::-webkit-scrollbar-thumb {
				background-color: ${COLORS.brand};
				border-radius: 50px;
			}
		}
		.rt-th,
		.rt-td {
			white-space: pre-wrap !important;
		}
		.rt-thead.-header {
			z-index: 5;
			background-color: ${COLORS.brandLight};
			box-shadow: none !important;
			padding-right: 20px;
			position: sticky;
			top: 0;
		}
		.rt-thead .rt-th,
		.rt-thead .rt-td {
			padding: 1rem 0;
			text-align: start;
			color: ${COLORS.tableHeader};
			font-weight: 500;
			text-transform: capitalize;
			font-size: 16px;
			border: none;
			div {
				display: flex;
				align-items: center;
				justify-content: center;
			}
			&.-cursor-pointer {
				box-shadow: none !important;
				display: flex;
				justify-content: center;
				align-items: center;
				&:before {
					content: "\f362";
					font-size: 0.75rem !important;
					font-family: "Font Awesome 6 Free";
					font-weight: 900;
					color: #1CBAA7 !important;
					background-color: transparent !important;
					transform: rotate(90deg);
				}
			}
			&.-sort-desc.-cursor-pointer {
				box-shadow: none !important;
				display: flex;
				justify-content: center;
				align-items: center;
				&:before {
					content: "\f175" !important;
					font-size: 0.75rem !important;
					font-family: "Font Awesome 6 Free";
					font-weight: 900;
					color: #1CBAA7 !important;
					background-color: transparent !important;
					transform: rotate(0);
				}
			}

			&.-sort-asc.-cursor-pointer {
				box-shadow: none !important;
				display: flex;
				justify-content: center;
				align-items: center;
				&:before {
					content: "\f176" !important;
					font-size: 0.75rem !important;
					font-family: "Font Awesome 6 Free";
					font-weight: 900;
					color: #1CBAA7 !important;
					background-color: transparent !important;
					transform: rotate(0);
				}
			}
		}
		.rt-tbody {
			padding-right: 0.3rem;
			overflow-y: initial;
			overflow-x: hidden;
			::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}
			::-webkit-scrollbar-track {
				background-color: ${COLORS.light};
				border-radius: 50px;
				margin-bottom: 10px;
			}
			::-webkit-scrollbar-thumb {
				background-color: ${COLORS.brand};
				border-radius: 50px;
			}
			.rt-td {
				border: none;
			}
			.rt-tr-group {
				border: none;
				box-shadow: ${COLORS.tableBoxShadow};
				background-color: ${COLORS.light};
				padding: 0.5rem 0;
				font-size: 14px;
				font-weight: 500;
				text-transform: capitalize;
				margin-bottom: 15px;
				border-radius: 10px;
				flex: none;
			}
			.rt-tr {
				align-items: center;
				justify-content: space-evenly;
			}
		}
	}
	ul {
		list-style: none;
		display: flex;
		justify-content: center;
		align-items: center;
		li {
			margin: 0 10px;
			font-size: 12px;
			border-radius: 5px;
			padding: 0;
			font-weight: 500;
			height: 30px;
			width: 30px;
			text-align: center;
			a {
				display: inline-block;
				padding: 6px 10px;
				svg: {
					padding: 0;
				}
			}
			&.page-item {
				background-color: ${COLORS.light};
				transition: all 0.25s ease-in-out;
			}
			&.page-item.disabled {
				visibility: hidden;
			}
			&.page-item.active {
				background-color: ${COLORS.brandDark};
				color: ${COLORS.light};
			}
			:first-child {
				a {
					padding: 7px 5px;
					svg {
						font-size: 14px !important;
					}
				}
				background-color: ${COLORS.brand};
			}
			:last-child {
				a {
					padding: 7px 5px;
					svg {
						font-size: 14px !important;
					}
				}
				background-color: ${COLORS.brand};
			}
		}
	}
`;

const TableStyle = ({ children, version = 7 }) => {
	return <>{version === 7 ? <Styles>{children}</Styles> : <StylesV6>{children}</StylesV6>}</>;
};

export default TableStyle;
